import { ArrowRight, Users, Star, TrendingUp } from 'lucide-react';

const stats = [
  { icon: Users, label: 'Doctors Served', value: '200+' },
  { icon: Star, label: 'Average Rating', value: '4.9' },
  { icon: TrendingUp, label: 'Patient Growth', value: '3x' },
];

const Hero = () => (
  <section className="relative bg-[#F9F7F2] overflow-hidden" data-testid="hero-section">
    <div className="max-w-7xl mx-auto px-6 py-16 lg:py-28">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div className="space-y-8 animate-fade-in-up">
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#8C6330]">
            Healthcare Digital Marketing & Accounting
          </p>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none font-light text-[#11181C]">
            Scale Your Practice.
            <br />
            <span className="text-[#1B3F33] font-medium">We Handle the Rest.</span>
          </h1>
          <p className="text-base leading-relaxed text-[#4A5568] max-w-lg">
            Emplozera Studio is the premier digital marketing and accounting partner for
            forward-thinking doctors and clinics. We drive patient acquisition while ensuring
            your finances are flawless.
          </p>
          <div className="flex flex-wrap gap-4">
            <a
              href="#consultation"
              className="inline-flex items-center gap-2 bg-[#1B3F33] text-white hover:bg-[#265E4A] rounded-full px-8 py-4 text-sm font-medium transition-all duration-300 group"
              data-testid="hero-cta-primary"
            >
              Book a Strategy Session
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="#services"
              className="inline-flex items-center gap-2 border border-[#1B3F33]/25 hover:border-[#1B3F33] text-[#1B3F33] rounded-full px-8 py-4 text-sm font-medium transition-all duration-300"
              data-testid="hero-cta-secondary"
            >
              Explore Services
            </a>
          </div>
        </div>

        <div className="relative animate-fade-in stagger-2">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl">
            <img
              src="https://customer-assets-eiarnc6j.emergentagent.net/job_clinic-elevate/artifacts/67ngk7ei_smiling-young-blonde-female-doctor-wearing-medical-robe-stethoscope-around-neck-looking-pointing-side.webp"
              alt="Doctor pointing to services"
              className="w-full h-[420px] lg:h-[500px] object-cover"
              data-testid="hero-image"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1B3F33]/25 to-transparent" />
          </div>
          <div className="absolute -bottom-4 -left-4 sm:-bottom-6 sm:-left-6 bg-white border border-[#D6CEBF] rounded-2xl p-5 shadow-lg">
            <p className="text-2xl sm:text-3xl font-heading font-semibold text-[#1B3F33]">200+</p>
            <p className="text-sm text-[#4A5568]">Clinics Trust Us</p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-6 sm:gap-8 mt-16 lg:mt-20 pt-10 lg:pt-12 border-t border-[#D6CEBF]">
        {stats.map((stat) => (
          <div key={stat.label} className="text-center" data-testid={`stat-${stat.label.toLowerCase().replace(/\s/g, '-')}`}>
            <stat.icon size={22} className="mx-auto mb-2 text-[#8C6330]" />
            <p className="text-xl sm:text-3xl font-heading font-semibold text-[#1B3F33] stat-number">{stat.value}</p>
            <p className="text-xs sm:text-sm text-[#4A5568] mt-1">{stat.label}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Hero;
